<template>
  <section></section>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { authStore } from '@/stores/auth'
import { audioStore } from '@/stores/audio'
import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr'
import globals from '@/plugins/globals'
export default {
  name: 'ServiceHub',
  data() {
    return {
      connection: null,
      signalRstatus: '',
      signalRerror: '',
      connectedInterval: 0,
      signalrUrl: ''
    }
  },
  mounted() {
    this.signalrUrl = window.config ? window.config.signalrUrl : ''
    this.initSignalR()
  },
  computed: {
    ...mapState(authStore, ['profile']),
    isAdmin() {
      let _is = false
      if (this.profile.roles[0] === 1 || this.profile.roles[0] === 2) {
        _is = true
      }
      return _is
    },
    isProvider() {
      let _is = false
      if ([2, 3].includes(this.profile.connectClass)) {
        _is = true
      }
      return _is
    }
  },
  methods: {
    ...mapActions(audioStore, ['playSound']),
    initSignalR() {
      try {
        // Initialize SignalR
        if (this.connection === null) {
          this.connection = new HubConnectionBuilder()
            .withUrl(this.signalrUrl)
            .withAutomaticReconnect([0, 3000, 5000, 10000, 15000, 30000, 60000])
            .configureLogging(LogLevel.Information)
            .build()
          // Listen to "sendMessage"
          this.connection.on('sendMessage', (data) => {
            if (data !== undefined && data !== null) {
              if (globals.isJson(data)) {
                let msg = JSON.parse(data)
                if (msg.name === 'ImportData') {
                  this.emitter.emit('process-dataimport', msg.data)
                } else if (msg.type === 'Opportunity' && (this.isProvider || this.isAdmin)) {
                  this.emitter.emit('process-opportunity', msg)
                } else if (msg.type === 'OpportunityStatus' && (this.isProvider || this.isAdmin)) {
                  this.emitter.emit('process-opportunity-status', msg)
                } else if (msg.type === 'OpportunityReceipt' && (this.isProvider || this.isAdmin)) {
                  // this.emitter.emit('process-opportunity-receipt', msg)
                  this.emitter.emit('process-opportunity', msg)
                  if (parseInt(this.profile.firm) === parseInt(msg.target)) {
                    console.log('Received Opportunity', msg)
                    this.playSound()
                  }
                }
              }
            }
          })
          // Start SignalR connection
          this.connection
            .start()
            .then(() => {
              console.log('Service Hub Started')
            })
            .catch((err) => {
              console.error(err.toString())
            })
        }
      } catch (e) {
        console.error('Error: serviceHub > initSignalR', e)
      }
    }
  },
  beforeUnmount() {
    this.connection.stop().then(() => {
      this.connection = null
      console.log('Service Hub Stopped')
    })
  }
}
</script>
<style lang="scss" scoped></style>
